import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Alert,
  Box,
  CircularProgress,
  Paper,
  Typography,
} from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import { useAuth } from '../../contexts/AuthContext';
import LoginButton from '../../components/auth/LoginButton';
import unifiedApi from '../../utils/unifiedApi';

const RsvpResponsePage = () => {
  const { token, choice } = useParams();
  const [status, setStatus] = useState('pending');
  const [message, setMessage] = useState('');
  const { isAuthenticated } = useAuth();
  const hasSubmitted = useRef(false);

  useEffect(() => {
    if (hasSubmitted.current) return;
    hasSubmitted.current = true;

    const respond = async () => {
      try {
        const data = await unifiedApi.respondToRsvp(token, choice);
        setStatus('success');
        setMessage(data.message || 'RSVP submitted!');
      } catch (err) {
        setStatus('error');
        setMessage(err.message || 'Something went wrong.');
      }
    };

    respond();
  }, [token, choice]);

  return (
    <Box sx={{ textAlign: 'center', py: 4, px: 2 }}>
      <Typography variant="h4" gutterBottom>
        RSVP Response
      </Typography>
      {status === 'pending' && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, mt: 2 }}>
          <CircularProgress size={20} />
          <Typography>Submitting your RSVP...</Typography>
        </Box>
      )}
      {status === 'success' && (
        <Alert severity="success" sx={{ maxWidth: 500, mx: 'auto', mt: 2 }}>
          {message}
        </Alert>
      )}
      {status === 'error' && (
        <Alert severity="error" sx={{ maxWidth: 500, mx: 'auto', mt: 2 }}>
          {message}
        </Alert>
      )}

      {!isAuthenticated && (
        <Paper
          elevation={1}
          sx={{
            maxWidth: 500,
            mx: 'auto',
            mt: 4,
            p: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <LoginIcon color="primary" sx={{ fontSize: 40 }} />
          <Typography variant="body1" color="text.secondary">
            Login to set your full availability and view your stats &amp; schedule
          </Typography>
          <LoginButton variant="contained" color="primary">
            Log In
          </LoginButton>
        </Paper>
      )}
    </Box>
  );
};

export default RsvpResponsePage;
